import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { servicesProviderExternalFeesDataSchema } from './ServicesProviderExternalFeesData.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';

class ServicesProviderExternalFees extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderExternalFeesDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderExternalFees.validation', `ServicesProviderExternalFees data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.EXTERNAL_FEES,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.EXTERNAL_FEES, ServicesProviderExternalFees);

export { ServicesProviderExternalFees };
//# sourceMappingURL=ServicesProviderExternalFees.js.map
